import { z } from 'zod';

import { ExitRouteValue } from './scoreRoute.js';

export const KEBAB = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** The node types the player renders; endings come in four kinds. */
export const NODE_TYPES = ['activity', 'ending', 'ending:rich', 'ending:wallet', 'ending:checklist'] as const;
export type NodeType = (typeof NODE_TYPES)[number];

export const CHARACTER_ROLES = ['friend', 'manager', 'rival', 'self'] as const;

/**
 * An activity as the template schemas see it: a type and a setup. Which types exist and
 * what each setup holds is judged per node by the activity modules (`validateActivity`),
 * so the template schemas never keep a second list of either.
 */
export const NodeActivity = z.looseObject({
  type: z.string(),
  name: z.string().optional(),
  setup: z.record(z.string(), z.unknown()).optional(),
});

/** Fields every template's node shares. */
export const nodeFields = {
  id: z.string().regex(KEBAB),
  nodeType: z.enum(NODE_TYPES),
  activity: NodeActivity.optional(),
  exitRoutes: z.record(z.string(), ExitRouteValue).optional(),
  completeStateFlag: z.string().optional(),
};

/** Narrator and background fields the story-like templates share. */
export const narratorFields = {
  narratorName: z.string().min(1).optional(),
  narratorSpriteUrl: z.string().optional(),
  narratorContentAssetSlug: z.string().optional(),
  defaultBackgroundContentAssetSlug: z.string().optional(),
  defaultBackgroundMobileContentAssetSlug: z.string().optional(),
};
